import { data } from '../../svg/EmailTemplate/data';
import { makeIcon } from '../makeIcon';

export const EmailTemplate = makeIcon(data, 'email_template', 'EmailTemplate');

export default EmailTemplate;
